import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchCustomers, customerLogout } from 'actions/customerList';
import { fetchCurrentStaff } from 'actions/navHeader';
import { clearCustomerCheckout } from 'actions/checkout';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

let _content = null;

const CustomerList = (props) => {
  const {
    fetchCustomers,
    customerLogout,
    fetchCurrentStaff,
    clearCustomerCheckout,
    location,
  } = props;

  const [customer, setCustomer] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [mailValidation, setMailValidation] = useState(true);

  useEffect(() => {
    const { state } = location;
    fetchCurrentStaff();
    customerLogout(state ? state.keepBasket : false);
    clearCustomerCheckout();
  }, []);

  const getCustomers = (customer) => {
    fetchCustomers(customer, currentPage);
  };

  const changeHandler = (value, name) => {
    const val = value.trim();
    const newCustomer = {
      ...customer,
      [name]: val,
    };

    const encodedCustomer = {};
    Object.keys(newCustomer).forEach((key) => {
      encodedCustomer[key] = encodeURIComponent(newCustomer[key]);
    });

    if (['TFS'].includes($A.BRAND)) {
      if (name === 'email') {
        const emailRegex = /\S+@\S+\.\S+/;
        if (emailRegex.test(val.toString())) {
          setTimeout(() => {
            setMailValidation(false);
            setTimeout(() => {
              getCustomers(encodedCustomer);
            }, 250);
          }, 250);
        } else {
          setTimeout(() => {
            setMailValidation(true);
          }, 250);
        }
      }
      setCustomer(newCustomer);
      if (name === 'phone' && val.length >= 0) {
        setTimeout(() => {
          getCustomers(encodedCustomer);
        }, 250);
      }
    } else {
      setCustomer(newCustomer);
      if (val.length > 2) {
        setTimeout(() => {
          getCustomers(encodedCustomer);
        }, 250);
      }
    }
    setCurrentPage(1);
  };

  const removeFilterParameter = (field) => {
    let _customer = customer;
    setCustomer({ ..._customer, [field]: null });
    getCustomers(customer);
  };

  const pageChangeHandler = (currentPage) => {
    setCurrentPage(currentPage);
    getCustomers(customer);
  };

  return (
    _content &&
    _content({
      props,
      customer,
      currentPage,
      mailValidation,
      getCustomers,
      changeHandler,
      removeFilterParameter,
      pageChangeHandler,
    })
  );
};

const mapStateToProps = (state) => ({
  pending: state.customerList.pending,
  error: state.customerList.error,
  customers: state.customerList.customers,
  count: state.customerList.count,
});

const mapDispatchToProps = {
  fetchCustomers,
  customerLogout,
  fetchCurrentStaff,
  clearCustomerCheckout,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(CustomerList);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/customer/customerList/index.js